import { render, staticRenderFns } from "./TableUsuariosNotFound.vue?vue&type=template&id=b587a17e"
import script from "./TableUsuariosNotFound.vue?vue&type=script&lang=js"
export * from "./TableUsuariosNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports